
export const shouldShowFeature = (state, featureId) => state.application.features.data[featureId]

export const getAllFeatures = state => {
  const { data } = state.application.features
  const features = []
  for (const id in data) {
    features.push({ id, enabled: data[id] })
  }
  return features
}

export const isShowingFeatureEditor = state => state.application.features.isShowingEditor



// WEBPACK FOOTER //
// ./selectors/features.js